"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.Button = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _FocusStyles = require("../../../../../FocusStyles");
const Button = exports.Button = _styledComponents.default.button.withConfig({
  displayName: "styles__Button",
  componentId: "sc-1td8vqi-0"
})(["background-color:transparent;cursor:pointer;padding:0;", ";&[aria-expanded='true']{outline:none;}"], _FocusStyles.focusStyles);
const Container = exports.Container = _styledComponents.default.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1td8vqi-1"
})(["position:relative;"]);